export default __webpack_public_path__ + "static/media/invoices.f16a5234.svg";